// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import BlankCanvas from "../common/illustrations/BlankCanvas";

type Props = {
  classes: Object,
  message?: string,
  theme: Object,
};

const NoListings = ({ message, classes }: Props) => {
  return (
    <div className={classes.root}>
      <BlankCanvas />
      <Typography
        className={classNames(classes.notFound, classes.heading)}
        type="heading2"
      >
        No Listings Found
      </Typography>
      <Typography
        className={classNames(classes.notFound, classes.body)}
        type="body"
      >
        {message ||
          `Sorry, we could not find any listings that match your criteria. Please
        try broadening your search.`}
      </Typography>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "24px 0px 48px",
  },
  notFound: {
    margin: "0px auto",
    width: "100%",
    maxWidth: "375px",
    textAlign: "center",
  },
  illustration: {
    width: "100%",
    height: "100%",
  },
  heading: {
    marginTop: theme.spacing.unit * 0.75,
    fontSize: "26px",

    [theme.breakpoints(600)]: {
      fontSize: "32px",
    },
  },
  body: {
    color: theme.colors.gray["600"],
    fontSize: "18px",
    lineHeight: "1.5",
    padding: "0px 24px",
  },
}))(NoListings);
